function circOut(t) {
  return Math.sqrt(1 - ( --t * t ))
}

module.exports = circOut